import React, { useState } from 'react';
import { connect } from 'react-redux'
import { FaCog } from 'react-icons/fa';
import {Container, Image} from 'react-bootstrap'
import EditProfile from './EditProfile'
import {updateUser, deleteUser} from '../../actions/actions'
import { withRouter } from 'react-router-dom';

function Profile(props) {
    const [showEdit, toggleShowEdit] = useState(false);

    const handleDelete = () => {
      window.scrollTo(0, 0);
      props.deleteUser(props.user.id)
      localStorage.removeItem('jwt') 
      props.history.push("/")
    } 

    const submitChanges = data => {
      // toggleShowEdit(!showEdit)
      props.updateUser(data.name, data.imgSrc, data.bio, props.user.id)
      window.scrollTo(0, 0);
    } 

    const ckProfilePathExact = window.location.pathname.replace("/", "")
    // const ckProfilePathExact = window.location.hash.replace("#/", "")
        if ((props.isLoggedIn && props.myAccount) || (props.isLoggedIn && /^profile$/.test(ckProfilePathExact))) {
            return (
              <Container className="profile">
                <Image src={props.user.img_src} className="profileIMG" rounded />                  
                <div className="details">
                    <p>{props.user.name} &nbsp;
                        <span>
                            <FaCog className="cog" style={{color: "rgb(42, 151, 233)"}} onClick={() => toggleShowEdit(!showEdit)}></FaCog>
                        </span>
                    </p>
                    <p>
                        <b>Cupping Tables: {props.user.tables_length} </b>
                    </p>
                    <p>{props.user.bio ? props.user.bio : "(click gear to add bio)"}</p>
                </div>
                {showEdit ? <EditProfile toggleShowEdit={toggleShowEdit} showEdit={showEdit} user={props.user} submitChanges={submitChanges} handleDelete={handleDelete}/> : null}
              </Container>
            )
        } else if (props.anotherUser) {
            return (
                <Container className="profile">
                    <Image src={props.anotherUser.img_src} className="profileIMG" rounded />                  
                    <div className="details">
                        <p>{props.anotherUser.name} </p>
                        <p>
                        <b>Cupping Tables: {props.anotherUser.tables_length}</b>
                        </p>
                        <p>{props.anotherUser.bio ? props.anotherUser.bio : null}</p>
                    </div>
                </Container>
            )
        }
        else {
            return (
              <Container className="profile">
                <Image src={props.user.img_src} className="profileIMG" rounded />                  
                <div className="details">
                    <p>{props.user.name} </p>
                    <p>
                    <b>Cupping Tables: {props.userTables ? ` ${props.userTables.length}` : ` ${props.user.tables_length}`} </b>
                    </p>
                    <p>{props.user.bio ? props.user.bio : null}</p>
                </div>
              </Container>
            )
        }

}

const msp = state => {
	return {
        isLoggedIn: state.users.isLoggedIn,
        user: state.users.user,
        anotherUser: state.users.anotherUser,
        userTables: state.users.userTables,
        table: state.cuppings.table
	}
  };
  
  export default connect(msp, {
    updateUser, deleteUser
  })(withRouter(Profile))